//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import SUB_BASIC_01 from './SUB_BASIC_01';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useDelete from '../../../../hooks/useDeleteN';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useDelete1,
  useDelete2,
  useSave1,
  useSave2,
} from './SUB_BASIC_01_QUERY';
import { useSave } from '../../../../hooks/useSaveN';
import { SUB_BASIC_01_Schema } from './SUB_BASIC_01_Schema';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'SubcontractorManagement';

const INPUTS = {
  sbmId: null, // 평가 목록 ID
  sbmYear: dayjs().format('YYYY'), // 평가 년도 (기본: 올해)
  partnerCd: '', // 수급업체 코드
  sbdId: null, // 평가표 ID
  deductions: 0, // 감점점수
  totalScore: 0, // 총점수
  evaluatorOpinion: '', // 평가자 의견
  grade: '', // 평가등급
};

// 평가표 항목
const EvaluationItems = [
  {
    no: 1,
    item: '사업주의 관심',
    standard:
      '책임자의 안전보건에 대한 관심도\n도급인과 수급인 사업자의 안전보건방침 부합여부',
    pointValue: 10,
    score: '',
  },
  {
    no: 2,
    item: '안전보건회의 실시',
    standard: '도급사업장 협의체 회의 참석여부',
    pointValue: 10,
    score: '',
  },
  {
    no: 3,
    item: '위험요인 파악제거 (위험성평가)',
    standard:
      '위험요인 파악, 제거 및 통제 방법의 적정성\n근로자의 참여 (위험성평가 및 대책수립)',
    pointValue: 10,
    score: '',
  },
  {
    no: 4,
    item: '보호구 지급,착용',
    standard: '적정 안전보호구 지급 및 착용',
    pointValue: 10,
    score: '',
  },
  {
    no: 5,
    item: '근로자 교육',
    standard: '작업 근로자 안전교육 실시',
    pointValue: 10,
    score: '',
  },
  {
    no: 6,
    item: '안전점검',
    standard: '작업전 안전점검, 안전보건 정기 점검 실시',
    pointValue: 10,
    score: '',
  },
  {
    no: 7,
    item: '자원 배정',
    standard:
      '안전보건관리를 위한 적정인원 배정 및 운영\n(안전관리 선임, 전문업체 대행 등)',
    pointValue: 10,
    score: '',
  },
  {
    no: 8,
    item: '위험물질 및 설비',
    standard: '유해위험물질, 취급 기계기구의 안전성 확인',
    pointValue: 10,
    score: '',
  },
  {
    no: 9,
    item: '비상조치계획',
    standard:
      '비상시 작업중지, 대피 등 적합한 비상조치계획\n비상연락망 등 연락체계 구축',
    pointValue: 10,
    score: '',
  },
  {
    no: 10,
    item: '작업환경측정 및 건강검진',
    standard: '작업환경측정, 근로자 건강검진 실시 여부',
    pointValue: 10,
    score: '',
  },
];

// 감정항목
const DeductionItems = [
  {
    no: 11,
    item: '감점사항',
    standard:
      '사망 또는 반기 2건이상 재해발생 10점\n반기 1건이상 재해 발생 5점 ',
    pointValue: 10,
    score: '',
  },
];

// 등급표 항목
const GradeItems = [
  {
    no: 1,
    grade: 'A',
    score: '90점 이상',
    standard: '도급 작업을 안전하게 수행할 역량이 우수함',
  },
  {
    no: 2,
    grade: 'B',
    score: '80점 이상',
    standard: '도급작업을 안전하게 수행할 기본적인 역량을 갖춤',
  },
  {
    no: 3,
    grade: 'C',
    score: '70점 이상',
    standard: '도급작업을 수행할 안전보건관리 역량이 보통임',
  },
  {
    no: 4,
    grade: 'D',
    score: '60점 이상',
    standard: '도급작업을 수행할 안전보건관리 역량이 부족함',
  },
  {
    no: 5,
    grade: 'E',
    score: '60점 미만',
    standard: '도급작업을 수행할 안전보건관리 역량이 매우 낮음',
  },
];
//#endregion

function SUB_BASIC_01F(props) {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const dispatch = useDispatch();
  //왼쪽 그리드
  const [rowData1, setRowData1] = useState([]); // 협력업체 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 협력업체 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 협력업체 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);

  const [modalToggle6, setModalToggle6] = React.useState(false); //근로자 목록 보기 설정하기 팝업
  const [modalRowData6, setModalRowData6] = useState([]); //근로자 목록 보기 설정하기 팝업 그리드 데이터
  const [selectedModalRowData6, setSelectedModalRowData6] = useState([]); //근로자 목록 보기 설정하기 팝업 ROW선택 데이터

  const [modalToggle1, setModalToggle1] = React.useState(false); // 평가표 팝업 토글
  // 평가표 헤더/폼 상태 (합계, 평가년도, 평가자 의견, 등급 등)
  const [modalRowData1, setModalRowData1] = React.useState(INPUTS);
  const [modalToggle2, setModalToggle2] = React.useState(false); // 수급업체 평가 목록 리스트 화면 이동 버튼, 수정 팝업 창
  const [modalRowData2, setModalRowData2] = React.useState([]); // 수급업체 평가 목록 리스트 화면 이동 버튼, 수정 팝업 창
  const [selectedPartner, setSelectedPartner] = useState('');
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [selectedModalRowData2, setSelectedModalRowData2] = useState(null); // 모달2에서 선택된 행
  const baseInfoRef = useRef(null); // SearchLogic3에서 사용할 baseInfo 저장

  const gridRef1 = useRef(); //회사정보 그리드

  // 평가표 list 관련 변수
  const [items, setItems] = useState(EvaluationItems);
  const [deductions, setDeductions] = useState(DeductionItems);
  //#endregion

  const toStr = (v) => String(v ?? '').trim();
  const toNum = (v, d = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : d;
  };

  useEffect(() => {
    calculateTotalScore();
  }, [items, deductions]);

  useEffect(() => {
    if (!modalToggle2 || !selectedPartner) return;
    Search2({ partnerCd: selectedPartner });
  }, [
    searchInfo?.modalStartYear,
    searchInfo?.modalEndYear,
    modalToggle2,
    selectedPartner,
  ]);

  //#region 쿼리
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(
        (rows || []).map((row) => ({
          ...row,
          residentYn: row.residentYn === 'Y' ? '상주' : '비상주',
        }))
      );
    },
  });
  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  const SearchLogic1 = async () => {
    ResetLogic1();
    await Search1();
  };

  // 수급업체 평가 목록 조회
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      setModalRowData2(rows);
    },
  });

  // 수급업체 평가표 조회
  const { run: Search3, runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      const data = rows || [];
      const baseInfo = baseInfoRef.current;

      if (!data || data.length === 0) {
        setModalRowData1({
          ...INPUTS,
          partnerCd: baseInfo?.partnerCd || '',
          sbmYear: baseInfo?.sbmYear,
        });

        setItems(EvaluationItems);
        setDeductions(DeductionItems);
        return;
      }

      if (data[0]?.type === 'Error') {
        throw new Error(data[0].message);
      }

      const row = data[0];

      setModalRowData1((prev) => ({
        ...prev,
        pointValueTotal: 100,
        partnerCd: baseInfo?.partnerCd ?? '',
        sbmId: row.sbmId ?? '',
        sbdId: row.sbdId ?? '',
        sbmYear: baseInfo?.sbmYear ?? dayjs().format('YYYY'),
        deductions: row.deductions ?? 0,
        totalScore: row.totalScore ?? 0,
        evaluatorEvaluation: row.evaluatorEvaluation ?? '',
        evaluatorOpinion: row.evaluatorOpinion ?? '',
        grade: row.grade ?? '',
      }));

      const hasDtlRows = data.some(
        (r) => r.itemName != null || r.evalStandard != null
      );
      if (hasDtlRows) {
        const dtlItems = data
          .filter((r) => String(r.isDeduction ?? 'N') !== 'Y')
          .map((r, idx) => ({
            no: toNum(r.sortOrdr, idx + 1),
            sbdId: r.sbdId ?? null,
            item: toStr(r.itemName),
            standard: toStr(r.evalStandard),
            pointValue: toNum(r.maxScore, 0),
            score: toNum(r.resultScore, 0),
          }))
          .sort((a, b) => a.no - b.no);
        setItems(dtlItems.length > 0 ? dtlItems : EvaluationItems);

        const deductionRows = data.filter(
          (r) => String(r.isDeduction ?? 'N') === 'Y'
        );
        const ded = deductionRows[0];
        setDeductions([
          {
            no: toNum(ded?.sortOrdr, 11),
            sbdId: ded?.sbdId ?? null,
            item: '감점사항',
            standard: toStr(ded?.evalStandard) || DeductionItems[0].standard,
            pointValue: toNum(ded?.maxScore, 10),
            score: toNum(ded?.resultScore, 0),
          },
        ]);
      } else {
        setItems(EvaluationItems);
        setDeductions(DeductionItems);
      }
    },
  });

  // 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 평가표 목록 삭제
  const delete2 = useDelete2();
  const deleteHandler2 = useDelete({
    deleteMutation: delete2,
    deletedRowData: deleteRow ? [deleteRow] : [],
  });

  // 저장
  // 협력업체 저장
  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '업체명',
    schema: SUB_BASIC_01_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    reset: ResetLogic1,
    refresh: Search1,
  });

  // 수급업체 평가표 저장
  const { runAsync: Save2Async } = useSave2();
  const { run: Save2 } = useSave({
    menuId: SCREEN_MENU_ID,
    getChangedRows: () => {
      const total = Number(modalRowData1.totalScore) || 0;
      let grade = 'E';

      if (total >= 90) grade = 'A';
      else if (total >= 80) grade = 'B';
      else if (total >= 70) grade = 'C';
      else if (total >= 60) grade = 'D';
      else grade = 'E';
      const detailRows = [
        ...(items || []).map((it, idx) => ({
          sbdId: it.sbdId ?? null,
          sortOrdr: Number(it.no) || idx + 1,
          itemName: String(it.item ?? ''),
          evalStandard: String(it.standard ?? ''),
          maxScore: Number(it.pointValue) || 0,
          resultScore: Number(it.score) || 0,
          isDeduction: 'N',
        })),
        ...(deductions || []).map((it, idx) => ({
          sbdId: it.sbdId ?? null,
          sortOrdr: Number(it.no) || items.length + idx + 1,
          itemName: String(it.item ?? ''),
          evalStandard: String(it.standard ?? ''),
          maxScore: Number(it.pointValue) || 0,
          resultScore: Number(it.score) || 0,
          isDeduction: 'Y',
        })),
      ];

      return [
        {
          ...modalRowData1,
          grade,
          detailRows,
        },
      ];
    },
    requestSave: (rows) => Save2Async(rows),
    afterSaveRow: (row, { savedRows }) => {
      const data = savedRows || [];
      const newSbmId = data?.[0]?.sbmId;
      const newSbdId = data?.[0]?.sbdId;

      if (newSbmId || newSbdId) {
        setModalRowData1((prev) => ({
          ...prev,
          sbmId: newSbmId ?? prev.sbmId,
          sbdId: newSbdId ?? prev.sbdId,
        }));
      }
    },
    onSuccessRefresh: async ({ saveDetailData }) => {
      const data = saveDetailData || [];
      const newSbmId = data?.[0]?.sbmId || modalRowData1.sbmId || 0;

      // 저장 후 재조회
      await Search3({
        sbmId: newSbmId,
        partnerCd: selectedPartner || '',
      });

      // 목록도 새로고침
      await Search2({ partnerCd: selectedPartner });
    },
  });
  const SaveLogic2 = async () => {
    const isValid = validateInputs();
    if (!isValid) return false;
    await Save2();
  };

  // 평가표 삭제 실행
  const { run: Save3 } = useSave({
    menuId: SCREEN_MENU_ID,
    getChangedRows: () => [],
    getDeletedRows: () => (deleteRow ? [deleteRow] : []),
    requestDelete: deleteHandler2.DeleteLogic,
    afterDeleteRow: async (item, { index, savedRows, userInfo }) => {
      // 삭제 후 목록 재조회
      await Search2({ partnerCd: selectedPartner });

      // 상태 초기화
      setDeleteRow(null);
      setDeleteConfirmOpen(false);
    },
  });
  //#endregion

  //#region 나머지 함수

  // 삭제 버튼 클릭 핸들러
  const deleteClick = (modalRowData2) => {
    setDeleteRow(modalRowData2);
    setDeleteConfirmOpen(true);
  };

  const validateInputs = () => {
    // 1~10 항목 배점 합계는 100 이하여야 함
    const pointTotal = (items || []).reduce(
      (sum, i) => sum + (Number(i.pointValue) || 0),
      0
    );
    if (pointTotal > 100) {
      dispatch(
        showSnackbar({
          message: '평가항목(1~10) 배점 합계는 100점을 초과할 수 없습니다.',
          type: 'error',
        })
      );
      return false;
    }

    // (평가년도는 더 이상 필수값으로 사용하지 않음)

    // 모든 검사 통과
    return true;
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  //인쇄 함수
  const PrintLogic1 = async () => {
    dispatch(showLoading());
    const custNm =
      searchInfo?.custList?.find((item) => item.value === searchInfo?.custCd)
        ?.name || '';
    try {
      if (!selectedModalRowData2) {
        dispatch(
          showSnackbar({
            message: '인쇄할 항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      }

      // 최신 상세행을 직접 받아 detailRows 기준으로 인쇄 데이터 구성
      const detailRows = await Search3Async({
        sbmId: selectedModalRowData2.sbmId,
        partnerCd: selectedPartner || '',
      });
      const dataRows = detailRows || [];
      if (!Array.isArray(dataRows) || dataRows.length === 0) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }
      if (dataRows[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: dataRows[0]?.message || '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      const base = dataRows[0] || {};
      const deductionRow = dataRows.find(
        (r) => String(r?.isDeduction ?? 'N') === 'Y'
      );
      const deductionScore =
        Number(deductionRow?.deductions ?? deductionRow?.resultScore) || 0;

      const headerData = {
        gradeYear: base.sbmYear || selectedModalRowData2.sbmYear || '',
        name: userInfo.userNm || '',
        updateDate:
          base.createDate || selectedModalRowData2.createDate
            ? dayjs(base.createDate || selectedModalRowData2.createDate).format(
                'YYYY-MM-DD'
              )
            : '',
        custNm: custNm || '',
        evaName: base.name || '',
        evaluatorOpinion: base.evaluatorOpinion || '',
        gradeFirstHalf: '',
        deductions: deductionScore,
        deductionItemName: String(deductionRow?.itemName ?? '감점사항'),
        deductionStandard: String(deductionRow?.evalStandard ?? ''),
        deductionScore,
        totalScore:
          Number(modalRowData1?.totalScore) || Number(base?.totalScore) || 0,
        grade: base.grade || '',
      };

      const tableData = dataRows
        .filter((r) => String(r?.isDeduction ?? 'N') !== 'Y')
        .slice()
        .sort((a, b) => (Number(a?.sortOrdr) || 0) - (Number(b?.sortOrdr) || 0))
        .slice(0, 10)
        .map((r, idx) => ({
          no: idx + 1,
          itemName: String(r?.itemName ?? ''),
          evalStandard: String(r?.evalStandard ?? ''),
          maxScore: Number(r?.maxScore) || 0,
          resultScore: Number(r?.resultScore) || 0,
          isDeduction: 'N',
          deductions: 0,
          totalScore:
            Number(modalRowData1?.totalScore) || Number(base?.totalScore) || 0,
        }));

      // 인쇄 실행
      const printData = {
        FileName: 'SUB_BASIC_01',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );
      const blobUrl = URL.createObjectURL(response.data);
      window.open(blobUrl, '_blank');
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const PrintLogic2 = async () => {
    dispatch(showLoading());

    let headerData = [];
    let tableData = [];

    const custNm =
      searchInfo?.custList?.find((item) => item.value === searchInfo?.custCd)
        ?.name || '';
    try {
      headerData.push({
        custNm: custNm,
      });
      tableData = rowData1;
      const printData = {
        FileName: 'SUB_BASIC_02',
        TableData: JSON.stringify(tableData),
        HeaderData: JSON.stringify(headerData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  // 평가표 이동 클릭 이벤트
  const PopupClickEvent1 = async (row) => {
    const sbmId = row?.sbmId;

    const baseInfo = {
      partnerCd: selectedPartner,
      sbmYear: row.sbmYear,
    };

    baseInfoRef.current = baseInfo;
    setModalToggle1(true);
    dispatch(showLoading());

    try {
      await Search3({
        sbmId: sbmId || 0,
        partnerCd: baseInfo.partnerCd || '',
      });
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const PopupClickEvent2 = async (_partnerCd) => {
    setModalToggle2(true);
    setSelectedPartner(_partnerCd);
  };
  const PopupClickEvent3 = async () => {
    setModalRowData1({
      ...INPUTS,
      partnerCd: selectedPartner,
      sbmYear: dayjs().format('YYYY'),
    });
    await PopupClickEvent1({
      sbmId: null,
      partnerCd: selectedPartner,
      sbmYear: dayjs().format('YYYY'),
    });
  };

  // 0 포함 비음수 정수 파싱 (단독 "0" 입력 허용)
  const ParseNonNegativeInt = (value, max = Infinity) => {
    const digits = String(value ?? '').replace(/\D/g, '');
    if (digits === '') return 0;
    const normalized =
      digits.length > 1 ? digits.replace(/^0+/, '') || '0' : digits;
    return Math.min(Number(normalized), max);
  };

  // 점수 변경 이벤트
  const onScoreChange = (no, value, max) => {
    const num = ParseNonNegativeInt(value, max);

    setItems((prev) =>
      prev.map((i) => (i.no === no ? { ...i, score: num } : i))
    );
  };

  const onItemFieldChange = (no, field, value) => {
    setItems((prev) =>
      prev.map((i) => {
        if (i.no !== no) return i;
        if (field === 'pointValue') {
          const otherSum = prev
            .filter((p) => p.no !== no)
            .reduce((sum, p) => sum + (Number(p.pointValue) || 0), 0);
          const allowedMax = Math.max(0, 100 - otherSum);
          const point = ParseNonNegativeInt(value, allowedMax);
          const score = Math.min(Number(i.score || 0), point);
          return { ...i, pointValue: point, score };
        }
        return { ...i, [field]: value };
      })
    );
  };

  const onDeductionChange = (idx, value, max) => {
    const num = ParseNonNegativeInt(value, max);

    setDeductions((prev) =>
      prev.map((i, iidx) => (iidx === idx ? { ...i, score: num } : i))
    );
  };

  const onDeductionFieldChange = (idx, field, value) => {
    setDeductions((prev) =>
      prev.map((i, iidx) => {
        if (iidx !== idx) return i;
        if (field === 'pointValue') {
          const point = ParseNonNegativeInt(value);
          const score = Math.min(Number(i.score || 0), point);
          return { ...i, pointValue: point, score };
        }
        return { ...i, [field]: value };
      })
    );
  };

  // 합계 계산 함수
  const calculateTotalScore = () => {
    const total =
      items.reduce((sum, i) => sum + (Number(i.score) || 0), 0) -
      deductions.reduce((sum, i) => sum + (Number(i.score) || 0), 0);

    setModalRowData1((prev) => ({ ...prev, totalScore: total }));
  };
  //#endregion
  //
  return (
    <SUB_BASIC_01
      navigate={navigate}
      userInfo={userInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      modalToggle6={modalToggle6}
      setModalToggle6={setModalToggle6}
      modalRowData6={modalRowData6}
      setModalRowData6={setModalRowData6}
      selectedModalRowData6={selectedModalRowData6}
      setSelectedModalRowData6={setSelectedModalRowData6}
      modalRowData1={modalRowData1}
      setModalRowData1={setModalRowData1}
      evaluationItems={items}
      deductionItems={deductions}
      gradeItems={GradeItems}
      gridRef1={gridRef1}
      dateValue={searchInfo}
      filterClick1={props.filterClick1}
      setFilterClick1={props.setFilterClick1}
      setDateValue={props.setDateValue}
      searchClick1={props.searchClick1}
      setSearchClick1={props.setSearchClick1}
      addClick1={props.addClick1}
      setAddClick1={props.setAddClick1}
      saveClick1={props.saveClick1}
      setSaveClick1={props.setSaveClick1}
      printClick1={props.printClick1}
      setPrintClick1={props.setPrintClick1}
      listClick1={props.listClick1}
      setListClick1={props.setListClick1}
      selectedRowNosRef={selectedRowNosRef}
      lastCheckedIndexRef={lastCheckedIndexRef}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      modalToggle2={modalToggle2}
      setModalToggle2={setModalToggle2}
      modalRowData2={modalRowData2}
      deletedRowData1={deletedRowData1}
      selectedPartner={selectedPartner}
      INPUTS={INPUTS}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      Save1={Save1}
      SaveLogic2={SaveLogic2}
      Save3={Save3}
      PrintLogic1={PrintLogic1}
      PrintLogic2={PrintLogic2}
      PopupClickEvent1={PopupClickEvent1}
      handleRowSelection={handleRowSelection}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      RestoreRow1={deleteHandler1.RestoreRow}
      NewYnErrorMsg={NewYnErrorMsg}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      onScoreChange={onScoreChange}
      onItemFieldChange={onItemFieldChange}
      onDeductionChange={onDeductionChange}
      onDeductionFieldChange={onDeductionFieldChange}
      PopupClickEvent2={PopupClickEvent2}
      PopupClickEvent3={PopupClickEvent3}
      deleteClick={deleteClick}
      deleteConfirmOpen={deleteConfirmOpen}
      setDeleteConfirmOpen={setDeleteConfirmOpen}
      deleteRow={deleteRow}
      setDeleteRow={setDeleteRow}
      selectedModalRowData2={selectedModalRowData2}
      setSelectedModalRowData2={setSelectedModalRowData2}
    />
  );
}

export default SUB_BASIC_01F;
